import { render, staticRenderFns } from "./ParcelshopList.vue?vue&type=template&id=f97aab30&scoped=true"
import script from "./ParcelshopList.vue?vue&type=script&lang=js"
export * from "./ParcelshopList.vue?vue&type=script&lang=js"
import style0 from "./ParcelshopList.vue?vue&type=style&index=0&id=f97aab30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97aab30",
  null
  
)

export default component.exports